import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import ArModal from "../../../components/Modal/ArModal";
import ItemTable from "../../../components/Content/ItemTable";
import DatePicker from "../../../components/DatePicker";
import FormAction from "../../../components/Actions/FormAction";

// Model
import { deposMasterModel } from "../../../../model/Purchase/DeposMasterModel";
import { deposDetailModel } from "../../../../model/Purchase/DeposDetailModel";

// Utils
import {
  getDataWithComp,
  getByDocId,
  getDocType,
  getTransType,
  getViewItem,
  getAlert,
  formatCurrency,
  parseCurrency,
  getSpRunNumber,
  deleteData,
  randomDelay,
} from "../../../../utils/SamuiUtils";

import {
  formatDateTime,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
} from "../../../../utils/DateUtils";

function Form({ callInitialize, mode, setMode, name, maxDocNo, getReport }) {
  const [formMasterList, setFormMasterList] = useState(deposMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [tbDocType, setTbDocType] = useState([]);
  const [tbTransType, setTbTransType] = useState([]);
  const [arDataList, setArDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);

  // การแสดงสถานะใบ
  const [statusName, setStatusName] = useState("");
  const [statusColour, setStatusColour] = useState("");

  // การแสดงสถานะประเภทการจ่าย
  const [payTypeName, setPayTypeName] = useState("");

  // เก็บสายส่ง
  const [dlLineId, setDlLineId] = useState("");
  const [dlLineName, setDlLineName] = useState("ไม่ระบุสายส่ง");
  const [dlLineList, setDlLineList] = useState([]); // เก็บสายส่งทั้งหมดที่ค้นหาได้

  // เก็บไฟล์รูปภาพกรณีจ่ายโอน
  const [filesImage, setFilesImage] = useState(null);
  const [base64Image, setBase64Image] = useState("");

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      const docTypeList = await getDocType(1);
      if (docTypeList && docTypeList.length > 0) {
        setTbDocType(docTypeList);
      }

      const transTypeList = await getTransType();
      if (transTypeList && transTypeList.length > 0) {
        setTbTransType(transTypeList);
      }

      const arDataList = await getDataWithComp(
        "Tb_Set_AR",
        "ORDER BY AR_Code ASC"
      );
      if (arDataList && arDataList.length > 0) {
        setArDataList(arDataList);
      }

      const itemDataList = await getViewItem();
      if (itemDataList && itemDataList.length > 0) {
        setItemDataList(itemDataList);
      }

      const whDataList = await getDataWithComp(
        "Tb_Set_WH",
        `AND Flag_Vansale = 'N' AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`
      );
      if (whDataList && whDataList.length > 0) {
        setWhDataList(whDataList);
      }

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo(arDataList);

        const findIdByNo = await getDataWithComp(
          "DEPOS_H", `AND Doc_No = '${maxDocNo}'`
        );

        // ค้นหาไฟล์ที่เกี่ยวข้อง (ปรับแต่งใหม่)
        if (findIdByNo[0].Doc_Id) {
          const image = await getDataWithComp(
            "Upload_File_List",
            `AND DocCode_ID = 5 AND Doc_ID = ${findIdByNo[0].Doc_Id}`
          );

          if (Array.isArray(image) && image.length > 0) {
            const fileNames = image.map((img) => img.File_Name);

            setFilesImage(fileNames);
          } else {
            setFilesImage([]);
          }
        } else {
          setFilesImage([]);
        }
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const getModelByNo = async (arDataList) => {
    try {
      // ค้นหาข้อมูลที่ตรงกับ AP_ID ใน apDataList
      const findMaster = await getDataWithComp("DEPOS_H", ``);
      const fromDatabase = findMaster.find(
        (depos) => depos.Doc_No === maxDocNo
      );

      if (!fromDatabase) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายด้วย AP_ID
      const fromViewAr = arDataList.find(
        (ap) => ap.AR_Id === fromDatabase.AR_ID
      );

      if (!fromViewAr) {
        throw new Error("ไม่พบข้อมูลลูกค้า");
      }

      // ค้นหาข้อมูล VIEW
      const findViewMaster = await getDataWithComp("API_0501_DEPOS_H", "");
      const fromView = findViewMaster.find((data) => data.Doc_No === maxDocNo);
      setStatusName(fromView.DocStatus_Name);
      setStatusColour(fromView.docsetcolour);
      setPayTypeName(fromView.Pay_Type_Name);

      // ค้นหาสายตามลูกค้าที่เลือกด้วยจ้า
      await findDeliveryLineNameById(fromDatabase.AR_ID);

      setDlLineId(fromView.DL_Id);
      setDlLineName(fromView.DL_LineName);

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        const itemDisType = String(itemSelected.Item_DisType);
        let itemTotal = itemQty * itemPriceUnit;

        itemTotal -=
          itemDisType === "2"
            ? (itemDiscount / 100) * itemTotal // ลดตามเปอร์เซ็นต์
            : itemDiscount; // ลดตามจำนวนเงิน

        return {
          ...deposDetailModel(index + 1),
          dtId: itemSelected.DT_Id,
          docId: itemSelected.Doc_ID,
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty, true),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit, true),
          itemDiscount: formatCurrency(itemDiscount, true),
          itemDisType,
          itemTotal,
          itemStatus: itemSelected.Item_Status,
          whId: itemSelected.WH_ID,
          whName: itemSelected.WH_Name,
          zoneId: itemSelected.Zone_ID,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
        };
      };

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromDetail = await getByDocId(
        "DEPOS_D",
        fromDatabase.Doc_Id,
        `ORDER BY Line ASC`
      );

      if (fromDetail.length > 0) {
        const newFormDetails = fromDetail.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );

        setFormDetailList(newFormDetails);

        setFormMasterList({
          docId: fromDatabase.Doc_Id,
          docNo: fromDatabase.Doc_No,
          docDate: fromDatabase.Doc_Date || null,
          docDueDate: fromDatabase.Doc_DueDate || null,
          docStatus: fromDatabase.Doc_Status,
          docCode: fromDatabase.Doc_Code,
          docType: fromDatabase.Doc_Type,
          docFor: fromDatabase.Doc_For,
          refDocID: fromDatabase.Ref_DocID,
          refDoc: fromDatabase.Ref_Doc,
          refDocDate: fromDatabase.Ref_DocDate,
          compId: fromDatabase.Comp_Id,
          refProjectID: fromDatabase.Ref_ProjectID,
          refProjectNo: fromDatabase.Ref_ProjectNo,
          transportType: fromDatabase.Transport_Type,
          docRemark1: fromDatabase.Doc_Remark1,
          docRemark2: fromDatabase.Doc_Remark2,
          arID: fromDatabase.AR_ID,
          arCode: fromDatabase.AR_Code,
          actionHold: fromDatabase.Action_Hold,
          discountValue: fromDatabase.Discount_Value,
          discountValueType: fromDatabase.Discount_Value_Type,
          discountCash: fromDatabase.Discount_Cash,
          discountCashType: fromDatabase.Discount_Cash_Type,
          discountTransport: fromDatabase.Discount_Transport,
          discountTransportType: fromDatabase.Discount_Transport_Type,
          isVat: fromDatabase.IsVat,
          docSEQ: fromDatabase.Doc_SEQ,
          creditTerm: fromDatabase.CreditTerm,
          creditTerm1Day: fromDatabase.CreditTerm1Day,
          creditTerm1Remark: fromDatabase.CreditTerm1Remark,
          creditTerm2Remark: fromDatabase.CreditTerm2Remark,
          accCode: fromDatabase.ACC_Code,
          empName: fromDatabase.EmpName,
          createdDate: setCreateDateTime(fromDatabase.Created_Date || null),
          createdByName: fromDatabase.Created_By_Name,
          createdById: fromDatabase.Created_By_Id,
          updateDate: setCreateDateTime(fromDatabase.Update_Date || null),
          updateByName: fromDatabase.Update_By_Name,
          updateById: fromDatabase.Update_By_Id,
          approvedDate: setCreateDateTime(fromDatabase.Approved_Date || null),
          approvedByName: fromDatabase.Approved_By_Name,
          approvedById: fromDatabase.Approved_By_Id,
          cancelDate: setCreateDateTime(fromDatabase.Cancel_Date || null),
          cancelByName: fromDatabase.Cancel_By_Name,
          cancelById: fromDatabase.Cancel_By_Id,
          approvedMemo: fromDatabase.Approved_Memo,
          printedStatus: fromDatabase.Printed_Status,
          printedDate: setCreateDateTime(fromDatabase.Printed_Date || null),
          printedBy: fromDatabase.Printed_By,
          confirmById: fromDatabase.Confirm_By_Id,
          confirmDate: setCreateDateTime(fromDatabase.Confirm_Date || null),
          confirmByName: fromDatabase.Confirm_By_Name,
          payType: fromDatabase.Pay_Type,
          approvedPayDate: setCreateDateTime(
            fromDatabase.Approved_Pay_Date || null
          ),
          approvedPayByName: fromDatabase.Approved_Pay_By_Name,
          approvedPayById: fromDatabase.Approved_Pay_By_Id,
          custName: fromDatabase.Cust_Name,
          custTel: fromDatabase.Cust_Tel,
          custMail: fromDatabase.Cust_Mail,
          custConfirmMemo: fromDatabase.Cust_Confirm_Memo,

          arName: fromViewAr.AR_Name,
          arAdd1: fromViewAr.AR_Add1,
          arAdd2: fromViewAr.AR_Add2,
          arAdd3: fromViewAr.AR_Add3,
          arProvince: fromViewAr.AR_Province,
          arZipcode: fromViewAr.AR_Zipcode,
          arTaxNo: fromViewAr.AR_TaxNo,
        });

        setIsVatChecked(fromDatabase.IsVat === 1);

        const discountValueType = parseCurrency(fromDatabase.Discount_Value_Type);
        if (!isNaN(discountValueType)) {
          setSelectedDiscountValueType(discountValueType.toString());
        }

        setSelectedDiscountValueType(String(fromDatabase.Discount_Value_Type));
      } else {
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const handleSubmit = async () => {
    try {
      // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
      await randomDelay();

      const newMaxDoc = await getSpRunNumber("DS");
      if (!newMaxDoc) {
        getAlert("FAILED", "ไม่สามารถสร้างเลขที่เอกสารได้");
        return;
      }

      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        getAlert("FAILED", "กรุณาเลือกลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: newMaxDoc,
        doc_date: formMasterList.docDate,
        doc_due_date: formMasterList.docDueDate,
        doc_status: parseCurrency("1", 10),
        doc_code: parseCurrency("5", 10),
        doc_type: parseCurrency(formMasterList.docType, 10),
        doc_for: formMasterList.docFor,
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_doc_date: formMasterList.refDocDate,
        comp_id: window.localStorage.getItem("company"),
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ar_id: parseCurrency(formMasterList.arID, 10),
        ar_code: formMasterList.arCode,
        action_hold: parseCurrency("0", 10),
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: parseCurrency("0.00"),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseCurrency("0.00"),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: parseCurrency("0", 10),
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: "0000",
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: window.localStorage.getItem("name"),
        created_by_id: window.localStorage.getItem("emp_id"),
        update_date: formMasterList.updateDate,
        update_by_name: formMasterList.updateByName,
        update_by_id: formMasterList.updateById,
        cancel_date: formMasterList.cancelDate,
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        printed_status: "N",
        printed_date: formMasterList.printedDate,
        printed_by: formMasterList.printedBy,
        confirm_by_id: formMasterList.confirmById,
        confirm_date: formMasterList.confirmDate,
        confirm_by_name: formMasterList.confirmByName,
        pay_type: formMasterList.payType,
        approved_pay_date: formMasterList.approvedPayDate,
        approved_pay_by_name: formMasterList.approvedPayByName,
        approved_pay_by_id: formMasterList.approvedPayById,
        cust_name: formMasterList.custName,
        cust_tel: formMasterList.custTel,
        cust_mail: formMasterList.custMail,
        cust_confirm_memo: formMasterList.custConfirmMemo,
        dl_id: dlLineId
      };

      // For Log DEPOS_H
      // console.log("formMasterData : ", formMasterData);

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-depos-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        const getDocIdResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-by-doc-no`,
          {
            table: "DEPOS_H",
            doc_no: formMasterData.doc_no,
            comp_id: window.localStorage.getItem("company"),
          },
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        // ส่งข้อมูลรายละเอียดหากพบ Doc_Id
        if (getDocIdResponse && getDocIdResponse.data.length > 0) {
          const docId = parseCurrency(getDocIdResponse.data[0].Doc_Id, 10);

          const detailPromises = formDetailList.map(async (item, index) => {
            const formDetailData = {
              doc_id: parseCurrency(docId, 10),
              line: index + 1,
              item_id: item.itemId,
              item_code: item.itemCode,
              item_name: item.itemName,
              item_qty: parseCurrency(item.itemQty),
              item_unit: item.itemUnit,
              item_price_unit: parseCurrency(item.itemPriceUnit),
              item_discount: parseCurrency(item.itemDiscount),
              item_distype:
                item.itemDisType === "1"
                  ? parseCurrency("1", 10)
                  : parseCurrency("2", 10),
              item_total: parseCurrency(item.itemTotal),
              item_status: parseCurrency("1", 10),
              wh_id: parseCurrency(item.whId, 10),
              zone_id: parseCurrency("1", 10),
              lt_id: parseCurrency("1", 10),
              ds_seq: formatDateTime(new Date()),
            };

            // For Log DEPOS_D
            // console.log("formDetailData : ", formDetailData);

            return Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-depos-d`,
              formDetailData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          });

          await Promise.all(detailPromises);
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    try {
      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        getAlert("FAILED", "กรุณาเลือกลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_date: formMasterList.docDate,
        doc_due_date: formMasterList.docDueDate,
        doc_status: parseCurrency(formMasterList.docStatus, 10),
        doc_code: parseCurrency(formMasterList.docCode, 10),
        doc_type: formMasterList.docType,
        doc_for: formMasterList.docFor,
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_doc_date: formMasterList.refDocDate,
        comp_id: formMasterList.compId,
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ar_id: parseCurrency(formMasterList.arID, 10),
        ar_code: formMasterList.arCode,
        action_hold: parseCurrency(formMasterList.actionHold, 10),
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(formMasterList.discountValueType, 10),
        discount_cash: parseCurrency(formMasterList.discountCash),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseCurrency(formMasterList.discountTransport),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formMasterList.docSEQ,
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: parseCurrency(formMasterList.creditTerm1Day, 10),
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: formMasterList.accCode,
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        cancel_date: formatThaiDateUiToDate(formMasterList.cancelDate),
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        printed_status: formMasterList.printedStatus,
        printed_date: formatThaiDateUiToDate(formMasterList.printedDate),
        printed_by: formMasterList.printedBy,
        confirm_by_id: formMasterList.confirmById,
        confirm_date: formMasterList.confirmDate,
        confirm_by_name: formMasterList.confirmByName,
        pay_type: formMasterList.payType,
        approved_pay_date: formMasterList.approvedPayDate,
        approved_pay_by_name: formMasterList.approvedPayByName,
        approved_pay_by_id: formMasterList.approvedPayById,
        cust_name: formMasterList.custName,
        cust_tel: formMasterList.custTel,
        cust_mail: formMasterList.custMail,
        cust_confirm_memo: formMasterList.custConfirmMemo,
        dl_id: dlLineId
      };

      // For Log DEPOS_H
      // console.log("formMasterData : ", formMasterData);

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-depos-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
        await deleteData("DEPOS_D", `WHERE Doc_ID = ${formMasterList.docId}`);

        const docId = parseCurrency(formMasterList.docId, 10);

        const detailPromises = formDetailList.map(async (item, index) => {
          const formDetailData = {
            doc_id: parseCurrency(docId, 10),
            line: index + 1,
            item_id: item.itemId,
            item_code: item.itemCode,
            item_name: item.itemName,
            item_qty: parseCurrency(item.itemQty),
            item_unit: item.itemUnit,
            item_price_unit: parseCurrency(item.itemPriceUnit),
            item_discount: parseCurrency(item.itemDiscount),
            item_distype: item.itemDisType,
            item_total: parseCurrency(item.itemTotal),
            item_status: parseCurrency("1", 10),
            wh_id: parseCurrency(item.whId, 10),
            zone_id: parseCurrency(item.zoneId, 10),
            lt_id: parseCurrency(item.ltId, 10),
            ds_seq: item.dsSeq,
          };

          // For Log DEPOS_D
          // console.log("formDetailData : ", formDetailData);

          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-depos-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        await Promise.all(detailPromises);

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // For Log DEPOS_H
      // console.log("formMasterData : ", formMasterData);

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-depos-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleApprovedPay = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseCurrency("3", 10),
        approved_pay_date: formatThaiDateUiToDate(getCreateDateTime()),
        approved_pay_by_name: window.localStorage.getItem("name"),
        approved_pay_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/approved-pay-depos-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value ? value.format('YYYY-MM-DD') : null,
    }));
  };

  const handleChangeDetail = (index, field, value) => {
    // ตรวจสอบว่าค่าที่กรอกเข้ามาเป็นตัวเลขหรือตัวเลขที่มีจุดทศนิยม
    if (!/^\d*\.?\d*$/.test(value)) {
      //getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");
      return;
    }

    const updatedList = [...formDetailList];
    updatedList[index][field] = value;

    const itemQty = parseCurrency(updatedList[index].itemQty) || 0;
    const itemPriceUnit = parseCurrency(updatedList[index].itemPriceUnit) || 0;
    const itemDiscount = parseCurrency(updatedList[index].itemDiscount) || 0;
    const itemDisType = String(updatedList[index].itemDisType);

    let itemTotal = itemQty * itemPriceUnit;

    if (itemDisType === "2") {
      itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
    } else {
      itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
    }

    updatedList[index].itemTotal = itemTotal;
    setFormDetailList(updatedList);
  };

  const handleFocus = (index, field) => {
    const updatedList = [...formDetailList];
    updatedList[index][field] =
      parseCurrency(updatedList[index][field].replace(/,/g, "")) || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(
      numericValue,
      field === "itemQty" || field === "itemPriceUnit"
    );

    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };

  // SET AR
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = async (arSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        arID: arSelected.AR_Id,
        arCode: arSelected.AR_Code,
        arName: arSelected.AR_Name,
        arAdd1: arSelected.AR_Add1,
        arAdd2: arSelected.AR_Add2,
        arAdd3: arSelected.AR_Add3,
        arProvince: arSelected.AR_Province,
        arZipcode: arSelected.AR_Zipcode,
        arTaxNo: arSelected.AR_TaxNo,
      });

      // ค้นหาสายตามลูกค้าที่เลือกด้วยจ้า
      await findDeliveryLineNameById(arSelected.AR_Id);

      handleArClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const onRowSelectItem = (itemsSelected) => {
    try {
      setFormDetailList([
        ...formDetailList,
        ...itemsSelected.map((itemSelected) => {
          return {
            line: null,
            itemId: itemSelected.Item_Id,
            itemCode: itemSelected.Item_Code,
            itemName: itemSelected.Item_Name,
            itemQty: formatCurrency(0),
            itemUnit: itemSelected.Item_Unit_ST,
            itemPriceUnit: formatCurrency(itemSelected.Item_Cost || 0),
            itemDiscount: formatCurrency(0),
            itemDisType: "1",
            itemTotal: 0,
            itemStatus: itemSelected.Item_Status,
            whId: null,
            whName: itemSelected.WH_Name,
            zoneId: null,
            ltId: null,
            dsSeq: null,
          };
        }),
      ]);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };
  const handleRemoveRow = async (index) => {
    setFormDetailList([]);
    setTimeout(() => {
      const newList = formDetailList.filter((_, i) => i !== index);
      setFormDetailList(newList);
    }, 50);
  };

  const findDeliveryLineNameById = async (arId) => {
    const deliveryLine = await getDataWithComp('View_DL_Line', `AND DL_AR_Id = ${arId}`);
    setDlLineList(deliveryLine || []);
    if (deliveryLine && deliveryLine.length > 0) {
      setDlLineId(deliveryLine[0].DL_Id);
      setDlLineName(deliveryLine[0].DL_LineName);
    } else {
      setDlLineId("");
      setDlLineName("ไม่ระบุสายส่ง");
      setDlLineList([]);
    }
  };

  // การคำนวณยอดรวม (totalPrice)
  useEffect(() => {
    const total = formDetailList.reduce(
      (acc, item) => acc + (parseCurrency(item.itemTotal) || 0), 0
    );
    setTotalPrice(total);
  }, [formDetailList]);

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    // let discountValue = parseCurrency(formMasterList.discountValue || 0);
    // let receiptDiscount = 0;
    // if (selectedDiscountValueType === '2') { // เปอร์เซ็นต์
    //     receiptDiscount = (totalPrice / 100) * discountValue;
    // } else if (selectedDiscountValueType === '1') { // จำนวนเงิน
    //     receiptDiscount = discountValue;
    // }
    // setReceiptDiscount(receiptDiscount);
  }, [totalPrice, formMasterList.discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    // const vat = isVatChecked ? subFinal * 0.07 : 0;
    // setVatAmount(parseCurrency(vat.toFixed(2)));
  }, [subFinal, isVatChecked]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const grandTotal = subFinal + vatAmount;
    setGrandTotal(parseCurrency(grandTotal));
  }, [subFinal, vatAmount]);

  return (
    <>
      <Breadcrumbs
        page={maxDocNo}
        isShowStatus={mode === "U"}
        statusName={statusName}
        statusColour={statusColour}
        otherTypeName={payTypeName}
        otherTypeColour={'#0F6CBD'}
        items={[
          { name: "จัดซื้อสินค้า", url: "/purchase" },
          { name: name, url: "/deposit-document" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
        onHandleClick={() => getReport("depos", formMasterList.docNo)}
        urlImg={filesImage}
        base64Image={base64Image}
        setBase64Image={setBase64Image}
      />
      <div className="hidden-scrollbar" style={{ maxHeight: "auto", overflowY: "auto" }}>
        <div className="row">
          <div className="col-3 text-left">
            <DatePicker
              label="วันที่เอกสาร"
              name="docDate"
              value={formMasterList.docDate}
              onChange={(date) => handleChangeDateMaster(date, "docDate")}
              disabled={mode === "U"}
            />
          </div>
          <div className="col-3 text-center">
            <div className="d-flex align-items-center">
              <label>ลูกค้า</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="apCode"
                  value={
                    (formMasterList.arCode || "") +
                    " " +
                    (formMasterList.arName || "")
                  }
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleArShow}
                  disabled={mode === "U" ? true : false}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <ArModal
              showArModal={showArModal}
              handleArClose={handleArClose}
              arDataList={arDataList}
              onRowSelectAr={onRowSelectAr}
            />
          </div>
          <div className="col-3 text-left">
            <div className="d-flex align-items-center">
              <label>ชื่อลูกค้า</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={formMasterList.custName || ""}
                  disabled={true}
                />
              </div>
            </div>
          </div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdDate"
                value={formMasterList.createdDate}
                // onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3 text-left">
            <div className="d-flex align-items-center">
              <label>อ้างอิงเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="refDoc"
                value={formMasterList.refDoc || ""}
                onChange={handleChangeMaster}
                disabled={mode === "U"}
              />
            </div>
          </div>
          <div className="col-3 text-center">
            <div className="d-flex align-items-center">
              <label>ที่อยู่</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="apAdd1"
                value={formMasterList.arAdd1 || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-3 text-left">
            <div className="d-flex align-items-center">
              <label>เบอร์ลูกค้า</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={formMasterList.custTel || ""}
                  disabled={true}
                />
              </div>
            </div>
          </div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdByName"
                value={formMasterList.createdByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3 text-left">
            <DatePicker
              label="วันที่เอกสารอ้างอิง"
              name="refDocDate"
              value={formMasterList.refDocDate}
              onChange={(date) => handleChangeDateMaster(date, "refDocDate")}
              disabled={formMasterList.docStatus === 1 ? false : true}
            />
          </div>
          <div className="col-3 text-center">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.arAdd2 || "") +
                  " " +
                  (formMasterList.arAdd3 || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-3 text-left">
            <div className="d-flex align-items-center">
              <label>อีเมลลูกค้า</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={formMasterList.custMail || ""}
                  disabled={true}
                />
              </div>
            </div>
          </div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formMasterList.updateDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3 text-left">
            {/* <div className="d-flex align-items-center">
                        <label>ประเภทเอกสาร</label>
                        <select
                            className="form-select form-control input-spacing"
                            name="docType"
                            value={formMasterList.docType}
                            onChange={handleChangeMaster}
                            disabled={docStatus !== 1}
                        >
                            {tbDocType.map((docType) => (
                                <option key={docType.DocType_Id} value={docType.DocType_Id}>
                                    {docType.DocType_Name}
                                </option>
                            ))}
                        </select>
                    </div> */}
          </div>
          <div className="col-3 text-center">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.arProvince || "") +
                  " " +
                  (formMasterList.arZipcode || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-3 text-left">
            <div className="d-flex align-items-center">
              <label>หมายเหตุลูกค้า</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={formMasterList.custConfirmMemo || ""}
                  disabled={true}
                />
              </div>
            </div>
          </div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้แก้ไขเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateByName"
                value={formMasterList.updateByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3 text-left">
            {/* <div className="d-flex align-items-center">
                        <label>วัตถุประสงค์</label>
                        <select
                            name="docFor"
                            value={formMasterList.docFor}
                            onChange={handleChangeMaster}
                            className="form-select form-control input-spacing"
                            disabled={docStatus !== 1}>
                            <option value="1">ซื้อมาเพื่อใช้</option>
                            <option value="2">ซื้อมาเพื่อขาย</option>
                        </select>
                    </div> */}
          </div>
          <div className="col-3 text-center">
            <div className="d-flex align-items-center">
              <label>เลขที่ภาษี</label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.arTaxNo || ""}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-3 text-left">
            <div className="d-flex align-items-center">
              <div className="row">
                <div className="col-3">
                  <label>ช่องทางการชำระ</label>
                </div>
                <div className="col-1" />
                <div className="col-6">
                  <div className="radio-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={formMasterList.payType === 1}
                      disabled={true}
                    />
                    <label className="form-check-label">เงินสด</label>
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={formMasterList.payType === 2}
                      disabled={true}
                    />
                    <label className="form-check-label">เงินโอน</label>
                  </div>
                </div>
                <div className="col-2" />
              </div>
            </div>
          </div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่อนุมัติ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="approvedPayDate"
                value={formMasterList.approvedPayDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3"></div>
          <div className="col-3 text-center">
            <div className="d-flex align-items-center">
              <label>สายส่ง</label>
              {dlLineList && dlLineList.length > 1 ? (
                <select
                  className="form-select form-control input-spacing"
                  value={dlLineId}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedLine = dlLineList.find((line) => String(line.DL_Id) === String(selectedId));
                    setDlLineId(selectedId);
                    setDlLineName(selectedLine ? selectedLine.DL_LineName : "");
                  }}
                  disabled={mode === "U"}
                >
                  <option value="">เลือกสายส่ง</option>
                  {dlLineList.map((line) => (
                    <option key={line.DL_Id} value={line.DL_Id}>
                      {line.DL_LineName}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={dlLineName || "ไม่ระบุสายส่ง"}
                  disabled={true}
                />
              )}
            </div>
          </div>
          <div className="col-3 text-center"></div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้อนุมัติเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="approvedByName"
                value={formMasterList.approvedPayByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3 text-left">
            {/* <div className="d-flex align-items-center">
                        <label>วิธีจัดส่ง</label>
                        <select
                            name="transportType"
                            value={formMasterList.transportType}
                            onChange={handleChangeMaster}
                            className="form-select form-control input-spacing"
                            disabled={docStatus !== 1}
                        >
                            {tbTransType.map((transType) => (
                                <option key={transType.Trans_TypeID} value={transType.Trans_TypeID}>
                                    {transType.Trans_TypeName}
                                </option>
                            ))}
                        </select>
                    </div> */}
          </div>
          <div className="col-6 text-left" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>หมายเหตุอนุมัติ</label>
              <input
                type="text"
                className="form-control input-spacing"
                // name="approvedMemo"
                // value={formMasterList.approvedMemo || ''}
                // onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <hr />
        <div className="row mt-2">
          <div className="col-6 ">
            <div className="d-flex align-items-center">
              <label>รายละเอียดเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark1"
                value={formMasterList.docRemark1 || ""}
                onChange={handleChangeMaster}
                maxLength={100}
                disabled={formMasterList.docStatus !== 1}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>หมายเหตุธุรการ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark2"
                value={formMasterList.docRemark2 || ""}
                onChange={handleChangeMaster}
                maxLength={500}
                disabled={formMasterList.docStatus !== 1}
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <ItemTable
            formDetailList={formDetailList}
            handleChangeDetail={handleChangeDetail}
            handleRemoveRow={handleRemoveRow}
            formatCurrency={formatCurrency}
            showItemModal={showItemModal}
            handleItemClose={handleItemClose}
            itemDataList={itemDataList}
            onRowSelectItem={onRowSelectItem}
            handleItemShow={handleItemShow}
            whDataList={whDataList}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            disabled={formMasterList.docStatus !== 1}
          />
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-4" />
                  <div className="col-4" />
                  <div className="col-4">
                    <div hidden={false}>
                      <h5 className="text-end mb-3">ยอดท้ายบิล</h5>
                      <div className="row mt-3">
                        <div className="col-12">
                          <div className="d-flex justify-content-end align-items-center mt-1">
                            <label>
                              <h5>รวมทั้งสิ้น</h5>
                            </label>
                            <input
                              type="text"
                              className="form-control text-end input-spacing"
                              style={{
                                width: "100px",
                                color: "red",
                                fontWeight: "bold",
                                fontSize: "18px",
                              }}
                              value={formatCurrency(grandTotal || 0)}
                              disabled={true}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FormAction
        onSubmit={handleSubmit}
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        onApprovedPay={handleApprovedPay}
        mode={mode}
        setMode={setMode}
        docStatus={formMasterList.docStatus}
        disabled={formMasterList.docStatus === 1 ? false : true}
        footer={true}
      />
      <br />
    </>
  );
}

export default Form;
